import { CheckCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { useNavigate } from "react-router-dom";

import { PATHS } from "../../constants/PATHS";
import { Description } from "../Description";
import { CustomButton } from "../FormFields/CustomButton";
import { Title } from "../Title";

export const PlannerImportSuccess = () => {
  const navigate = useNavigate();

  return (
    <Flex vertical align="center" justify="flex-start" gap={36} style={{ width: "100%" }}>
      <Title tagName="h2">Success</Title>
      <CheckCircleOutlined style={{ fontSize: 48, color: "green" }} />
      {/* <Progress
        percent={100}
        showInfo={false}
        status="success"
        style={{ width: "75%" }}
      /> */}
      <Description theme="t3">Import complete</Description>
      <CustomButton onClick={() => { navigate(PATHS.REPORTS_PATH); }}>
        Go to reports
      </CustomButton>
    </Flex> 
  );
};
